/**
 * Player Saga
 */
/* tslint:disable:space-before-function-paren */

import * as playerActions from '../actions/player';
import { showTrackDetails } from '../actions/ui';
import { CurrentTrackProps, getPlayerTrack, getTrackInfoFromQueue, TrackInfoSelector } from '../selectors/player';

import { effects as fx } from 'redux-saga';
import { Action } from 'typescript-fsa';

export function* init() {
  yield fx.all([
    fx.call(watchForPlayTrack),
    fx.call(watchForChangeTrack),
  ]);
}

const getTrackDetailsDrawerUIState = ({ ui }: IStoreState) => ui.trackDetails;

function* watchForPlayTrack() {
  while (true) {
    yield fx.take([
      playerActions.playNext,
      playerActions.playPrevious,
      playerActions.playTrackFromQueue,
    ]);

    const { trackId }: CurrentTrackProps = yield fx.select(getPlayerTrack);

    yield fx.put(playerActions.changeTrack({ trackId }));
  }
}

function* watchForChangeTrack() {
  while (true) {
    const { payload: { trackId } }: Action<IPlayTrackFromQueueActionPayload> = yield fx.take(playerActions.changeTrack);

    const trackDetails: ITrackDetailsDrawerUIState | undefined = yield fx.select(getTrackDetailsDrawerUIState);

    if (!!!trackDetails || trackDetails.visible === false) {
      continue;
    }

    if (trackId === trackDetails.trackInfo!.id) {
      continue;
    }

    const trackInfoSelector: TrackInfoSelector = yield fx.select(getTrackInfoFromQueue);
    const trackInfo = trackInfoSelector(trackId)!;

    yield fx.put(showTrackDetails({ trackInfo }));
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/player.ts